<template>
  <div id="app">
    <NavBar />
    
    <header class="header-fullwidth">
      <div class="header-container">
        <div class="header-content">
          <div class="header-text">
            <img alt="App logo" src="./assets/logo.png" class="logo">
            <h1>GO Count Object -Thing Counter</h1>
            <p class="tagline">Simple and efficient counting tool for easier data recording</p>
            <div class="header-buttons">
              <a href="#download" class="primary-btn">Download Now</a>
              <a href="#features" class="secondary-btn">Learn More</a>
            </div>
          </div>
          <div class="header-image">
            <img src="./assets/0.Bq937WgO.png" alt="App Screenshot" class="app-screenshot">
          </div>
        </div>
      </div>
      <div class="wave-divider">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100">
          <path fill="#ffffff" fill-opacity="1" d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,42.7C840,32,960,32,1080,37.3C1200,43,1320,53,1380,58.7L1440,64L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"></path>
        </svg>
      </div>
    </header>

    <div class="content-container">
      <section class="intro">
        <div class="intro-text">
          <h2>About GO Count</h2>
          <p>GO Count is a simple and easy-to-use item counting tool application that helps you easily record and manage various data. Whether it's fitness workout counts, daily habit formation, project progress tracking, or inventory management, GO Count can meet your needs.</p>
          <p>As a versatile counting tool, GO Count is more than just a simple counter - it's a data management assistant for your daily life and work. Through an intuitive user interface and powerful backend functionality, it helps you effortlessly record various types of data, from fitness workout counts to daily habit formation, from project progress tracking to inventory management, GO Count can meet all your needs.</p>
          <p>GO Count's design philosophy is "simple but not simplistic." We focus on providing core functionalities while ensuring each feature is carefully designed and optimized. Whether you need to track daily water intake, monitor fitness plan progress, or manage project milestones, GO Count offers convenient and efficient solutions.</p>
          <p>Our application supports multiple counting modes, including single counts, group counts, timed counts, and more, while providing detailed data statistics and visualization charts to help you better understand and analyze your data. Additionally, GO Count supports data export and backup features, ensuring your data is secure and easy to manage.</p>
          <p>Whether you're an individual user or a small team, GO Count provides professional and reliable counting tools to help you better organize your life and work. Download GO Count now and start your efficient data recording journey!</p>
        </div>
      </section>
      
      <section id="features" class="features section-block">
        <div class="section-container">
          <div class="section-header">
            <h2>Core Features</h2>
            <div class="section-divider"></div>
          </div>
          <div class="feature-grid">
            <div class="feature">
              <h3>Simple Counting</h3>
              <p>One-click addition, quickly record each count</p>
            </div>
            <div class="feature">
              <h3>Multi-Project Management</h3>
              <p>Manage multiple counting projects simultaneously with clear categorization</p>
            </div>
            <div class="feature">
              <h3>Data Statistics</h3>
              <p>Automatically generate charts to visually display your counting history</p>
            </div>
            <div class="feature">
              <h3>Goal Setting</h3>
              <p>Set target values and track completion progress</p>
            </div>
            <div class="feature">
              <h3>Data Management</h3>
              <p>Conveniently organize and categorize your count records</p>
            </div>
            <div class="feature">
              <h3>Reminder Function</h3>
              <p>Set timed reminders to never miss any counting time</p>
            </div>
          </div>
        </div>
      </section>

      <section id="screenshots" class="screenshots section-block">
        <div class="section-container">
          <div class="section-header">
            <h2>App Interface</h2>
            <div class="section-divider"></div>
          </div>
          <OwlCarousel />
        </div>
      </section>
      
      <section id="download" class="section-block">
        <div class="section-container">
          <div class="section-header">
            <h2>Download Now</h2>
            <div class="section-divider"></div>
          </div>
          <DownloadSection />
        </div>
      </section>
      
      <section id="about" class="section-block">
        <div class="section-container">
          <div class="section-header">
            <h2>About Us</h2>
            <div class="section-divider"></div>
          </div>
          <AboutPage />
        </div>
      </section>
    </div>

    <footer class="footer-fullwidth">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-logo">
            <img src="./assets/logo.png" alt="GO Count" class="footer-logo-img">
            <h3>GO Count Object -Thing Counter</h3>
            <p class="footer-slogan">Simple and efficient counting tool</p>
            <div class="social-icons">
              <a href="#" class="social-icon"><i class="fab fa-facebook-f"></i></a>
              <a href="#" class="social-icon"><i class="fab fa-twitter"></i></a>
              <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
              <a href="#" class="social-icon"><i class="fab fa-linkedin-in"></i></a>
            </div>
          </div>
          <div class="footer-links">
            <div class="footer-column">
              <h4>App</h4>
              <a href="#features">Core Features</a>
              <a href="#screenshots">App Interface</a>
              <a href="#download">Download</a>
            </div>
            <div class="footer-column">
              <h4>Support</h4>
              <a href="#">User Guide</a>
              <a href="/privacy">Privacy Policy</a>
              <a href="mailto:sl9283191@gmail.com">Contact Us</a>
            </div>
          </div>
        </div>
        <div class="footer-divider"></div>
        <div class="footer-bottom">
          <p>© 2024 GO Count Object -Thing Counter All Rights Reserved</p>
          <div class="footer-nav">
            <a href="/term">Terms of Use</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AboutPage from './components/About.vue'
import NavBar from './components/NavBar.vue'
import OwlCarousel from './components/OwlCarousel.vue'
import DownloadSection from './components/Download.vue'

export default {
  name: 'App',
  components: {
    AboutPage,
    NavBar,
    OwlCarousel,
    DownloadSection
  }
}
</script>

<style>
/* Styles have been moved to assets/custom.css */

/* Mobile optimization styles */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
  }
  
  .header-text {
    text-align: center;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .header-text .logo {
    width: 80px;
    height: auto;
    margin-bottom: 15px;
  }
  
  .header-text h1 {
    text-align: center;
    width: 100%;
    font-size: 2rem;
  }
  
  .header-image {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    padding: 0;
    overflow: visible;
  }
  
  .header-image img {
    max-width: 100%;
    width: 100%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }
  
  .feature-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
  }
  
  .section-block {
    padding: 40px 15px;
  }
  
  .section-header h2 {
    font-size: 1.8rem;
  }
  
  .header-buttons {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .primary-btn, .secondary-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
    text-align: center;
    min-width: 120px;
  }
  
  .intro-text p {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  .header-fullwidth {
    padding-top: 20px;
    padding-bottom: 0;
  }
  
  .header-text h1 {
    font-size: 1.5rem;
    padding: 0 10px;
  }
  
  .header-text .logo {
    width: 60px;
    margin-bottom: 10px;
  }
  
  .header-text .tagline {
    font-size: 1rem;
    padding: 0 15px;
    margin-bottom: 15px;
  }
  
  .header-buttons {
    flex-direction: column;
    width: 80%;
    gap: 10px;
    padding: 0;
    box-sizing: border-box;
    align-items: center;
    margin-bottom: 25px;
  }
  
  .header-buttons a {
    width: 100%;
    padding: 12px 15px;
    font-size: 1rem;
    text-align: center;
    max-width: 200px;
  }
  
  .header-image {
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }
  
  .header-image img {
    max-width: 120%;
    width: 120%;
    border-radius: 0;
    box-shadow: none;
    margin-left: -10%;
  }
  
  .wave-divider {
    margin-top: 0;
  }
  
  .feature-grid {
    grid-template-columns: 1fr !important;
  }
  
  .section-block {
    padding: 30px 10px;
  }
  
  .section-header h2 {
    font-size: 1.5rem;
  }
  
  .footer-content {
    flex-direction: column;
  }
  
  .footer-logo {
    margin-bottom: 30px;
  }
  
  .footer-links {
    flex-direction: column;
    width: 100%;
  }
  
  .footer-column {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
  }
  
  .intro-text p {
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 12px;
  }
}

.header-buttons {
  display: flex;
  gap: 15px;
  margin-top: 25px;
  justify-content: center;
}

.primary-btn, .secondary-btn {
  padding: 12px 25px;
  border-radius: 30px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
}

.primary-btn {
  background: linear-gradient(to right, #4a9ad8, #3a7ab6);
  color: white;
  box-shadow: 0 4px 15px rgba(74, 154, 216, 0.3);
}

.secondary-btn {
  background: white;
  color: #4a9ad8;
  border: 2px solid #4a9ad8;
  box-shadow: 0 4px 15px rgba(74, 154, 216, 0.1);
}

.primary-btn:hover, .secondary-btn:hover {
  transform: translateY(-3px);
}

.intro-text {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 0;
}

.intro-text h2 {
  color: #4a9ad8;
  margin-bottom: 20px;
  text-align: center;
}

.intro-text p {
  margin-bottom: 20px;
  line-height: 1.7;
  color: #444;
}

.footer-fullwidth {
  background: linear-gradient(to bottom, #f8fcff, #e8f4fc);
  padding: 60px 0 30px;
  margin-top: 50px;
  border-top: 1px solid rgba(74, 154, 216, 0.2);
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.footer-logo {
  flex: 1;
  max-width: 400px;
  margin-right: 40px;
}

.footer-logo-img {
  width: 60px;
  height: auto;
  margin-bottom: 15px;
}

.footer-logo h3 {
  font-size: 1.4rem;
  color: #4a9ad8;
  margin-bottom: 10px;
  font-weight: 600;
}

.footer-slogan {
  color: #666;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #4a9ad8;
  border-radius: 50%;
  color: white;
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-3px);
  background-color: #3a7ab6;
  box-shadow: 0 5px 15px rgba(74, 154, 216, 0.3);
}

.footer-links {
  display: flex;
  gap: 60px;
}

.footer-column {
  min-width: 160px;
}

.footer-column h4 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.1rem;
  position: relative;
  padding-bottom: 10px;
}

.footer-column h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, #4a9ad8, #3a7ab6);
}

.footer-column a {
  display: block;
  color: #666;
  text-decoration: none;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.footer-column a:hover {
  color: #4a9ad8;
  transform: translateX(3px);
}

.footer-divider {
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(74, 154, 216, 0.2), transparent);
  margin: 20px 0;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.footer-bottom p {
  color: #888;
  font-size: 0.85rem;
}

.footer-nav {
  display: flex;
  gap: 20px;
}

.footer-nav a {
  color: #666;
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.3s ease;
}

.footer-nav a:hover {
  color: #4a9ad8;
}

@media (max-width: 768px) {
  .footer-fullwidth {
    padding: 40px 0 20px;
  }
  
  .footer-content {
    flex-direction: column;
  }
  
  .footer-logo {
    margin-right: 0;
    margin-bottom: 30px;
    text-align: center;
    max-width: 100%;
  }
  
  .social-icons {
    justify-content: center;
  }
  
  .footer-links {
    width: 100%;
    justify-content: space-around;
  }
  
  .footer-column h4::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .footer-column {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .footer-links {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-column {
    width: 100%;
    margin-bottom: 0;
  }
}
</style>
